import React, { useEffect, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import api from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
    Box,
    Divider,
    Stack,
    Grid,
    Typography,
    Input,
    TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getId } from "../../../utils/Constant";
import ButtonWithLoader from "../../../utils/ButtonWithLoader";
import CustomLabel from "../../../CustomLable";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
// import CustomDataGrids from "../../../utils/CustomDataGrids";
import CustomDataGrid from "../../../utils/CustomDatagrid";
import dayjs from "dayjs";
import DataGrids from "../../../utils/Datagrids";

interface MenuPermission {
    isAdd: boolean;
    isEdit: boolean;
    isPrint: boolean;
    isDel: boolean;
}

export default function Taxmaster() {
    const Userid = getId();
    const [editId, setEditId] = useState(-1);
    const [zones, setZones] = useState([]);
    const [columns, setColumns] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    // const [lang, setLang] = useState<Language>;
    const [permissionData, setPermissionData] = useState<MenuPermission>({
        isAdd: false,
        isEdit: false,
        isPrint: false,
        isDel: false,
    });


    const { t } = useTranslation();

    useEffect(() => {
        // const dataString = localStorage.getItem("userdata");
        // if (dataString) {
        //   const data = JSON.parse(dataString);
        //   if (data && data.length > 0) {
        //     const userPermissionData = data[0]?.userPermission;
        //     if (userPermissionData && userPermissionData.length > 0) {
        //       const menudata = userPermissionData[0]?.parentMenu;
        //       for (let index = 0; index < menudata.length; index++) {
        //         const childMenudata = menudata[index]?.childMenu;
        //         const pathrow = childMenudata.find(
        //           (x: any) => x.path === location.pathname
        //         );

        //         if (pathrow) {
        //           console.log("data", pathrow);
        //           setPermissionData(pathrow);
        //         }
        //       }
        //     }
        //   }
        // }
        fetchZonesData();
    }, []);
    // }, [isLoading]);

    const handleConversionChange = (params: any, text: string) => {
        formik.setFieldValue(params, text);
    };

    const handleSwitchChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        value: any
    ) => {
        const collectData = {
            taxId: value.id,
            taxName: value.zoneName,
            taxPercentage: value.taxPercentage,
            effectiveDate: value.effectiveDate,
            isActive: event.target.checked,
            createdBy: "",
            updatedBy: "",
            createdOn: new Date().toISOString(),
            updatedOn: new Date().toISOString(),
        };
        console.log("collect Data addUpdate", collectData)
        api.post(`TaxMaster/AddUpdateTaxMaster`, collectData).then((response) => {
            if (response.data.isSuccess) {
                toast.success(response.data.mesg);
                fetchZonesData();
            } else {
                toast.error(response.data.mesg);
            }
        });
    };

    const routeChangeEdit = (row: any) => {
        console.log(row);
        console.log(dayjs(row.effectiveDate).format("DD-MM-YYYY"))
        formik.setFieldValue("taxId", row.taxId);
        formik.setFieldValue("taxName", row.taxName);
        formik.setFieldValue("taxPercentage", row.taxPercentage);
        formik.setFieldValue("effectiveDate", dayjs(row.effectiveDate).format("YYYY-MM-DD"));
        formik.setFieldValue("isActive", row.isActive);
        setEditId(row.id);
    };

    let delete_id = "";

    const accept = () => {
        const collectData = {
            taxId: delete_id,
        };
        console.log("collectData " + JSON.stringify(collectData));
        api
            .delete(`TaxMaster/DeleteTaxMaster`, { data: collectData })
            .then((response) => {
                if (response.data.isSuccess) {
                    toast.success(response.data.mesg);
                } else {
                    toast.error(response.data.mesg);
                }
                fetchZonesData();
            });
    };

    const reject = () => {
        toast.warn("Rejected: You have rejected", { autoClose: 3000 });
    };

    const handledeleteClick = (del_id: any) => {
        delete_id = del_id;
        confirmDialog({
            message: "Do you want to delete this record ?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            acceptClassName: "p=-button-danger",
            accept,
            reject,
        });
    };

    const fetchZonesData = async () => {
        try {
            const collectData = {
                taxId: -1,
            };
            const response = await api.post(`TaxMaster/GetTaxMaster`, collectData);
            const data = response.data.data;
            console.log("🚀 ~ fetchZonesData ~ response.data.data:", response.data.data)
            const zonesWithIds = data.map((zone: any, index: any) => ({
                ...zone,
                serialNo: index + 1,
                id: zone.taxId,
            }));
            setZones(zonesWithIds);
            setIsLoading(false);

            if (data.length > 0) {
                const columns: GridColDef[] = [
                    {
                        field: "actions",
                        // headerClassName: "MuiDataGrid-colCell",
                        headerName: t("text.Action"),
                        width: 150,

                        renderCell: (params) => {
                            return [
                                <Stack
                                    spacing={1}
                                    direction="row"
                                    sx={{ alignItems: "center", marginTop: "5px" }}
                                >
                                    {/* {permissionData?.isEdit ? ( */}
                                    <EditIcon
                                        style={{
                                            fontSize: "20px",
                                            color: "blue",
                                            cursor: "pointer",
                                        }}
                                        className="cursor-pointer"
                                        onClick={() => routeChangeEdit(params.row)}
                                    />
                                    {/* ) : (
                    ""
                  )}
                  {permissionData?.isDel ? ( */}
                                    <DeleteIcon
                                        style={{
                                            fontSize: "20px",
                                            color: "red",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            handledeleteClick(params.row.id);
                                        }}
                                    />
                                    {/* ) : (
                    ""
                  )} */}
                                    {/* <Switch
                                        checked={Boolean(params.row.isActive)}
                                        style={{
                                            color: params.row.isActive ? "green" : "#FE0000",
                                        }}
                                        onChange={(value: any) =>
                                            handleSwitchChange(value, params.row)
                                        }
                                        inputProps={{
                                            "aria-label": "Toggle Switch",
                                        }}
                                    /> */}
                                </Stack>,
                            ];
                        },
                    },

                    {
                        field: "serialNo",
                        headerName: t("text.SrNo"),
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "taxName",
                        headerName: t("text.taxName"),
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "taxPercentage",
                        headerName: t("text.taxPercentage"),
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "effectiveDate",
                        headerName: t("text.effectiveDate"),
                        flex: 1,
                        renderCell(params:any) {
                            // {console.log(params)}
                            return dayjs(params.row.effectiveDate).format("DD-MM-YYYY");
                        },
                        // headerClassName: "MuiDataGrid-colCell",
                    },
                    // {
                    //     field: "isActive",
                    //     headerName: t("text.Status"),
                    //     flex: 1,
                    //     headerClassName: "MuiDataGrid-colCell",
                    //     renderCell: (params) => [
                    //         <Stack direction="row" spacing={1}>
                    //             {params.row.isActive ? (
                    //                 <Chip
                    //                     label={t("text.Active")}
                    //                     color="success"
                    //                     style={{ fontSize: "14px" }}
                    //                 />
                    //             ) : (
                    //                 <Chip
                    //                     label={t("text.InActive")}
                    //                     color="error"
                    //                     style={{ fontSize: "14px" }}
                    //                 />
                    //             )}
                    //         </Stack>,
                    //     ],
                    // },
                ];
                setColumns(columns as any);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const adjustedColumns = columns.map((column: any) => ({
        ...column,
    }));

    const validationSchema = Yup.object({
        taxName: Yup.string().required("require tax Name"),
    });

    const requiredFields = ["taxName"];

    const formik = useFormik({
        initialValues: {
            taxId: -1,
            taxName: "",
            taxPercentage: "",
            effectiveDate:"",
            sortOrder: 0,
            isActive: true,
            user_ID: Userid,
            createdBy: Userid,
            updatedBy: Userid,
            createdOn: new Date().toISOString(),
            updatedOn: new Date().toISOString(),
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            values.taxId = editId;

            console.log("before submitting value check", values);
            const response = await api.post(`TaxMaster/AddUpdateTaxMaster`, values);
            if (response.data.isSuccess) {
                formik.setFieldValue("taxName", "");
                formik.setFieldValue("taxPercentage", "");
                fetchZonesData();
                toast.success(response.data.mesg);
                setEditId(-1);
            } else {
                toast.error(response.data.mesg);
            }
        },
    });

    const handleSubmitWrapper = async () => {
        await formik.handleSubmit();
    };

    return (
        <>
            <Card
                style={{
                    width: "100%",
                    backgroundColor: "lightgreen",
                    border: ".5px solid #2B4593",
                    marginTop: "3vh",
                }}
            >
                <Paper
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                        // backgroundColor:"lightseagreen"
                    }}
                    style={{ padding: "10px" }}
                >
                    <ConfirmDialog />

                    <Grid item xs={12} container spacing={1}>
                        <Grid item lg={10} md={10} xs={12}>
                            <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                sx={{ padding: "20px" }}
                                align="left"
                            >
                                {t("text.TaxMaster")}
                            </Typography>
                        </Grid>

                        <Grid item lg={2} md={2} xs={12} marginTop={2}>
                            <select
                                className="language-dropdown"
                                // value={lang}
                                // onChange={(e) => setLang(e.target.value as Language)}
                            >
                                {Languages.map((l) => (
                                    <option key={l.value} value={l.value}>
                                        {l.label}
                                    </option>
                                ))}
                            </select>
                        </Grid>
                    </Grid>

                    <Divider />

                    <Box height={10} />
                    <form onSubmit={formik.handleSubmit}>
                        <Grid item xs={12} container spacing={2}>
                            <Grid xs={12} sm={3} lg={3} item>
                                <TranslateTextField
                                    label={t("text.entertaxName")}
                                    value={formik.values.taxName}
                                    onChangeText={(text: string) => handleConversionChange('taxName', text)}
                                    required={true}
                                    lang={""}
                                />
                                {formik.touched.taxName && formik.errors.taxName ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {formik.errors.taxName}
                                    </div>
                                ) : null}
                            </Grid>

                            <Grid item xs={12} sm={3} lg={3}>
                                <TextField
                                    label={
                                        <CustomLabel
                                            text={t("text.entertaxPercentage")}
                                            required={false}
                                        />
                                    }
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="taxPercentage"  
                                    id="taxPercentage"   
                                    value={formik.values.taxPercentage}
                                    placeholder={t("text.entertaxPercentage")}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} lg={3}>
                                <TextField
                                    label={
                                        <CustomLabel
                                            text={t("text.entereffectiveDate")}
                                            required={false}
                                        />
                                    }
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="effectiveDate"  
                                    id="effectiveDate"   
                                    type="date"
                                    value={formik.values.effectiveDate}
                                    placeholder={t("text.entereffectiveDate")}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{shrink:true}}
                                />
                            </Grid>
                            

                            <Grid item xs={3} sx={{ m: -1 }}>
                                {editId === -1 && (
                                    // {editId === -1 && permissionData?.isAdd && (
                                    <ButtonWithLoader
                                        buttonText={t("text.save")}
                                        onClickHandler={handleSubmitWrapper}
                                        fullWidth={true}
                                    />
                                )}

                                {editId !== -1 && (
                                    <ButtonWithLoader
                                        buttonText={t("text.update")}
                                        onClickHandler={handleSubmitWrapper}
                                        fullWidth={true}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </form>

                    {isLoading ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <CircularProgress />
                        </div>
                    ) : (
                        <DataGrids
                            isLoading={isLoading}
                            rows={zones}
                            columns={adjustedColumns}
                            pageSizeOptions={[5, 10, 25, 50, 100]}
                            initialPageSize={5}
                        />
                    )}
                </Paper>
            </Card>
            <ToastApp />
        </>
    );
};